(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-form"] && !Shopify.designMode) return;
  try {
    
class openCloseHandler {
  allElements = document.querySelectorAll(".signup-form-section__header--container");

  constructor() {
    for (let elem of this.allElements) {
      elem.addEventListener("click", this.toggleAccordion.bind(this), false);
    }

    // Open the first section by default
    if (this.allElements.length > 0) {
      this.allElements[0].classList.add("expanded");
      const firstContent = this.allElements[0].nextElementSibling;
      firstContent.style.maxHeight = firstContent.scrollHeight + "px";
    }

    // Show success message on form submission
    const form = document.getElementById("AccountSignupForm");
    form.addEventListener("submit", this.showSuccessMessage.bind(this));
  }

  toggleAccordion(e) {
    const target = e.currentTarget;
    const content = target.nextElementSibling;

    if (target.classList.contains("expanded")) {
      target.classList.remove("expanded");
      content.style.maxHeight = null;
    } else {
      // Close all elements
      for (let elem of this.allElements) {
        elem.classList.remove("expanded");
        elem.nextElementSibling.style.maxHeight = null;
      }

      target.classList.add("expanded");
      content.style.maxHeight = content.scrollHeight + "px";
    }
  }

  showSuccessMessage(e) {
    e.preventDefault();
    const successMessage = document.getElementById("successMessage");
    successMessage.style.display = "block";
  }
}

window.openClose = new openCloseHandler();



  } catch(e) { console.error(e); }
})();
})();
